import React, { useState, useEffect } from "react";
import {
  Tree,
  Switch,
  Spin,
  Button,
  TreeNodeProps,
  Modal,
  Input,
  notification,
  Row,
  Col,
  Popconfirm,
  Breadcrumb,
  Space,
} from "antd";
import {
  CarryOutOutlined,
  FormOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { gaEvent } from "../../withTracker"
import {
  addOrganization,
  deleteOrganization,
} from "@axios/api.account";
import { OrganizationNodepProps } from "@axios/models";
import { DataNode } from "antd/lib/tree";
import Store from "@redux/store";
import { FetchingOrgsTree } from "@redux/actions";
import { getOrgsOptionsSelector } from "@redux/selector";
import { useDispatch, useSelector, useStore } from "react-redux";
import { RootStoreModel } from "@redux/reducers";

import { useTranslation } from "react-i18next";

export const Organization = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedNodeKey, setSelectedNodeKey] = useState<string>("");
  // const [data, setData] = useState<DataNode[]>([]);
  // const [dataSource, setDataSource] = useState<OrganizationNodepProps[]>([]);
  const [modalVisibility, setModalVisibility] = useState<boolean>(false);
  const [nodeName, setNodeName] = useState<string>("");
  const { t } = useTranslation();

  /* const dataSource = useSelector(
    (store: RootStoreModel) => store.userState.orgsTree
  ); */
  // const formatedData = useSelector(getOrgsOptionsSelector);
  // const [data, setData] = useState<DataNode[]>(formatedData);

  const formatedData = useSelector(getOrgsOptionsSelector) as DataNode[];

  const [data, setData] = useState<DataNode[]>(formatedData);
  
  const dispatch = useDispatch();
  const dispatchFetching = () => {
    dispatch(FetchingOrgsTree());
  };

  useEffect(() => {
    setData(formatedData);
  }, [formatedData]);

  const handleOk = () => {
    setLoading(true);
    addOrganization({
      name: nodeName,
      parentId: selectedNodeKey,
    }).then(() => {

      notification.success({ message: t("提交成功") });
      setModalVisibility(false);
      setNodeName("");
      // getData();
      // Store.dispatch(FetchingOrgsTree());
      dispatchFetching();
      setLoading(false);
    }, () => {
      setLoading(false);

    });
  };

  const onSelect = (selectedKeys: any, info: any) => {
    setSelectedNodeKey(selectedKeys[0]);
  };

  const deleteNode = (id: string) => {
    deleteOrganization(id).then(() => {
      notification.success({ message: t("已删除") });
      // getData();
      // Store.dispatch(FetchingOrgsTree());
      dispatchFetching();
    });
  };

  const TreeItem = (nodeData: OrganizationNodepProps) => {
    const { level, id, name, organizations } = nodeData;

    return (
      <li key={id} className="ps-3 py-2 my-2">
        <Row className="shadow-sm">
          <Col>
            <Button type="text" size="large">
              {name}
            </Button>{" "}
          </Col>
          <Col>
            <Button
              type="link"
              onClick={() => {
                setModalVisibility(true);
                setSelectedNodeKey(id);
                gaEvent("organization", "onClick", "setSelectedNodeKey");
              }}
            >
              +
            </Button>
            {level > 1 && (
              <Popconfirm
                title={`确认删除部门“${name}”？`}
                onConfirm={() => deleteNode(id)}
                onCancel={() => { }}
                okText="删除"
                cancelText="取消"
              >
                <Button type="link">-</Button>
              </Popconfirm>
            )}
          </Col>
        </Row>

        <ul>{organizations.map((item) => TreeItem(item))}</ul>
      </li>
    );
  };
  const handleCancel = () => { };

  return (
    (<div>
      <div className="breadcrumbTop py-2">
        <Breadcrumb>
          <Breadcrumb.Item>{t("设置")}</Breadcrumb.Item>
          <Breadcrumb.Item>{t("部门")}</Breadcrumb.Item>
        </Breadcrumb>
        <Row style={{padding: "32px 0 11px 0"}}>
            <Space>
                <img src="/images/organizationIcon.svg" alt="" />
                <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("部门")}</span>
            </Space>
        </Row>
      </div>
      {/* <h3 className="px-4">部门</h3> */}
      <Spin spinning={loading}>
        <Row style={{ width: "100%" }}>
          <div className="borderBox">
            <Tree
              showLine={true}
              showIcon={false}
              // expandedKeys={[data[0]?.key]}
              defaultExpandAll={true}
              onSelect={onSelect}
              treeData={data}
              titleRender={(node: any) => (
                <>
                  <Button type="text" className="ps-1 pe-5 py-0">
                    {node.title}
                  </Button>
                  {node.key === selectedNodeKey && (
                    <Button
                      type="link"
                      onClick={(e) => {
                        // e.preventDefault();
                        e.stopPropagation();
                        setModalVisibility(true);
                        setSelectedNodeKey(node.key as string);
                        gaEvent("organization", "onClick", "setSelectedNodeKey");
                      }}
                    >
                      <PlusCircleOutlined />
                    </Button>
                  )}
                  {node.key === selectedNodeKey &&
                    node.key !== data[0]?.key && (
                      <Popconfirm
                        title={`${t("确认删除部门")}“${node.title}”？`}
                        onConfirm={(e) => {
                          deleteNode(node.key as string);
                        }}
                        onCancel={() => { }}
                        okText={t("删除")}
                        cancelText={t("取消")}
                      >
                        <Button
                          type="link"
                          onClick={(e) => {
                            e.stopPropagation()
                            gaEvent("organization", "onClick", "stopPropagation");
                          }
                          }
                        >
                          <DeleteOutlined />
                        </Button>
                      </Popconfirm>
                    )}
                </>
              )}
            />

            {/* <ul>{dataSource.map((item) => TreeItem(item))}</ul> */}
          </div>
        </Row>
      </Spin>
      <Modal
        maskClosable={false}
        destroyOnClose={true}
        title={t("添加部门")}
        open={modalVisibility}
        onOk={handleOk}
        onCancel={() => {
          setModalVisibility(false);
          setNodeName("");
        }}
        confirmLoading={loading}
        okText={t("确认")}
        cancelText={t("取消")}
      >
        <Input
          placeholder={t("输入部门名称")}
          value={nodeName}
          onChange={(e) => setNodeName(e.target.value)}
        />
      </Modal>
    </div>)
  );
};
